import { Controller } from "@hotwired/stimulus"

// Controls the visibility of data source config fields on the objective form.
// When "mission_task" is selected, hides stock event config fields.
// When "stock_event_query" is selected, shows them.
export default class extends Controller {
  static targets = ["stockEventConfig", "missionTaskInfo"]

  connect() {
    this.toggle()
  }

  toggle() {
    const select = this.element.querySelector("[data-objective-data-source-select]")
    if (!select) return

    const isStockEvent = select.value === "stock_event_query"

    this.stockEventConfigTargets.forEach(el => {
      el.classList.toggle("hidden", !isStockEvent)
    })

    this.missionTaskInfoTargets.forEach(el => {
      el.classList.toggle("hidden", isStockEvent)
    })
  }
}
